/**
 * @desc 获取 OpenID 认证页面地址
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 会议号 */
  meetingId?: string;
  /** OAuth 的服务提供者，可选值有：NEOpenID、Oscar。默认值为 NEOpenID */
  provider?: string;
  /** 会议 URL 中的 pwd 参数 */
  pwd?: string;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/web/v3/open-auth/auth', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/web/v3/open-auth/auth',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/web/v3/open-auth/auth', params, 'GET'),
    {
      method: 'GET',

      ...options,
    },
  );
}
